module.exports = __webpack_public_path__ + "static/img/weixin.ce6fdbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weixin.png
// module id = AVav
// module chunks = 0